import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { get, sortBy } from 'lodash'
import uuid from 'uuid'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'
import { Modal } from 'containers/misc'
import { Title, Section } from 'components/layout'
import { Module, Button } from 'components/misc'
import { PersonRole } from 'components/sections/persons'
import { form } from 'helpers/decorators'
import { apiOrganizations, apiConfiguration } from 'helpers/decorators/api'
import { validate } from 'models/persons'
import { getActiveRole, personId as getPersonId } from 'utils/token'
import { RoleCreate, IafRoleCreate } from 'containers/forms/roles'
import { connect } from 'react-redux'
import { modal } from 'redux/modules/app'
import { CONFIGURATION_KEYS, ROLES } from 'constants/enums'
import styles from './role-change.styl'
import GopRoleCreate from '../GopRoleCreate/GopRoleCreate'

const enhance = compose(
  apiOrganizations({
    list: true,
    organizationFilter: '',
    params: 'ID,NAME',
    disableLimit: true,
    disableRootQueryParams: true
  }),
  apiConfiguration({
      getValues: [
        CONFIGURATION_KEYS.isGOPEnabled.id
      ]
    }),
  form({
    form: 'contact-role-management',
    disableHook: true,
    validate
  })
)

@connect(
  state => ({
    activeOrganization: state.auth.organization,
    roleDetail: state.api.persons.roleDetail
  }),
  {
    modal
  }
)
class RoleChange extends Component {
  static propTypes = {
    data: PropTypes.object.isRequired,
    persons: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    roleTypes: PropTypes.array.isRequired,
    modal: PropTypes.func.isRequired,
    initialize: PropTypes.func,
    configuration: PropTypes.object.isRequired,
    getOrganizations: PropTypes.func.isRequired,
    deletePersonRole: PropTypes.func.isRequired,
    getInfoAboutPersonRole: PropTypes.func.isRequired,
    addPersonRole: PropTypes.func,
    fetchOrganizationContactAllowedRoles: PropTypes.func.isRequired,
    getPersonRoles: PropTypes.func.isRequired,
    submitting: PropTypes.bool,
    loading: PropTypes.bool,
    activeOrganization: PropTypes.object,
    roleDetail: PropTypes.object
  }

  static defaultProps = {
    params: {}
  }

  constructor(props) {
    super(props)
    this.key = uuid.v1()
  }

  state = {
    isAddLoading: false,
    isEditLoading: false,
    roleToDelete: null,
    roleToEdit: null,
    activeIndexId: null,
    roleCount: null,
    isLastRole: null
  }

  isSuperUser = getActiveRole(this.props.activeOrganization) ===
    ROLES.IF_STAFF_SUPER.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.GBT.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.OA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.SOA.u ||
    getActiveRole(this.props.activeOrganization) === ROLES.IF_REGION.u

  isGOPStaff = getActiveRole(this.props.activeOrganization) ===  ROLES.GOP_STAFF.u

  async componentDidMount() {
    const { params, data, loading } = this.props

    if (loading) {
      return
    }

    await this.handleGetPersonRoles(get(data, 'person.id'))
  }

  async componentWillReceiveProps(nextProps) {
    const { params, data } = this.props

    if (
      !params.organizationId &&
      params.organizationId !== nextProps.params.organizationId
    ) {
      this.handleFormInit(nextProps.params.organizationId)
    }

    if (get(data, 'person.id') !== get(nextProps, 'data.person.id')) {
      await this.handleGetPersonRoles(nextProps.data.person.id)
    }
  }

  handleAddRole = () => {
    this.setState(
      {
        isAddLoading: true
      },
      () => {
        this.props.getOrganizations().then(() => {
          this.setState(
            {
              isAddLoading: false
            },
            () => {
              this.props.modal('modal-add-role')
            }
          )
        })
      }
    )
  }

  handleFormInit = id => {
    this.props.initialize({
      organizationId: Number(id)
    })
    this.props.fetchOrganizationContactAllowedRoles(id)
  }

  handleFormPrefill = role => {
    this.props
      .fetchOrganizationContactAllowedRoles(role.organizationId)
      .then(() => {
        this.props.initialize({
          organizationId: Number(get(role, 'organizationId')),
          organizationContactRoleType: {
            value: get(role, 'organizationContactRoleType.value')
          }
        })
      })
  }

  handleGetPersonRoles = async personId => {
    if (!personId) {
      return
    }

    await this.props.getPersonRoles(personId)
  }


  handleDeleteRoleModal = async(role, roleCount) => {
    const isOwnContact = getPersonId(this.props.user) === get(this.props.data, 'person.id')

    await this.props.getInfoAboutPersonRole(get(this.props.data, 'person.id'), role)
    this.setState({ roleToDelete: role, isOwnContact, roleCount, isLastRole: get(this.props.roleDetail, 'isLastRole') })
    this.props.modal('modal-delete-role')
  }

  handleDeleteRole = (role, isOwnContact, roleCount, shouldBeOrgContactDeleted = false) => {
    this.props.modal(null)
    this.props.deletePersonRole(get(this.props.data, 'person.id'), role, { isOwnContact, roleCount, shouldBeOrgContactDeleted })
  }

  render() {
    const {
      data,
      roleTypes,
      persons,
      submitting,
      configuration,
      addPersonRole,
      activeOrganization
    } = this.props

    const {
      isEditLoading,
      isAddLoading,
      activeIndexId
    } = this.state


    const isGOPEnabled = get(configuration, `valuesByOrganizationId[${get(activeOrganization, 'id')}][${CONFIGURATION_KEYS.isGOPEnabled.id}].booleanValue`)

    const sortedRoles = sortBy(
      get(persons, 'roles', []),
      'organizationContactRoleType.translationText'
    )

    const roleCount = sortedRoles.filter(role => role.organizationContactRoleType.value !== ROLES.COORDINATOR.role).length

    return (
      <Section>
        <Module
          title="Roles"
          intlKey="moduleTitle.roles"
          primary
          isActionLoading={isAddLoading}
        >
          <div className={`${styles.controls}`}>
          <Button
            className={`${styles.button}`}
            intlKey="button.add_role"
            type="button"
            onClick={() => this.props.modal('modal-create-role')}
          >
            Add role
          </Button>

          {this.isSuperUser && <Button
            className={`${styles.button}`}
            intlKey="button.add_iaf_role"
            type="button"
            onClick={() => this.props.modal('modal-iaf-create-role')}
          >
            Add IAF role
            </Button>}

            {(this.isSuperUser || this.isGOPStaff) && isGOPEnabled && <Button
                className={`${styles.button}`}
                intlKey="button.add_gop_role"
                type="button"
                onClick={() => this.props.modal('modal-gop-create-role')}
            >
              Add GOP role
            </Button>}

          </div>
          <Section loading={persons.loading} inBox>
            {sortedRoles.map((role, index) => (
              <PersonRole
                key={index}
                id={index}
                role={role}
                isLoading={activeIndexId === index ? isEditLoading : false}
                contactId={get(role, 'id')}
                configuration={configuration}
                organizationId={get(data, 'organization.id')}
                roleCount={roleCount}
                deletePersonRole={this.handleDeleteRoleModal}
              />
            ))}
            {!persons.loading &&
            get(persons, 'roles', []).length === 0 &&
            <FormattedMessage
              id="label.no_roles"
              defaultMessage="No roles"
            />}
          </Section>
        </Module>

        <Modal id="modal-create-role" customActions fluid >
          <RoleCreate
            data={data}
            fetchOrganizationContactAllowedRoles={this.props.fetchOrganizationContactAllowedRoles}
            roleTypes={roleTypes}
            onClose={() => this.props.modal(null)}
            addPersonRole={addPersonRole}
          />
        </Modal>

        <Modal id="modal-iaf-create-role" customActions fluid>
          <IafRoleCreate
            data={data}
            fetchOrganizationContactAllowedRoles={this.props.fetchOrganizationContactAllowedRoles}
            roleTypes={roleTypes}
            onClose={() => this.props.modal(null)}
            addPersonRole={addPersonRole}
          />
        </Modal>

        <Modal id="modal-gop-create-role" customActions fluid>
          <GopRoleCreate
              data={data}
              fetchOrganizationContactAllowedRoles={this.props.fetchOrganizationContactAllowedRoles}
              roleTypes={roleTypes}
              onClose={() => this.props.modal(null)}
              addPersonRole={addPersonRole}
          />
        </Modal>

        <Modal id="modal-delete-role" customActions>
          <div>
            <Title h2 intlKey="moduleTitle.delete_role">
              Delete role
            </Title>

            <div className="row">
              <div className="col-xs-12">
                <span>{get(this.state.roleToDelete, 'organizationContactRoleType.translationText')}</span><br />
                <span>{get(this.state.roleToDelete, 'organizationName')}</span><br /><br />

                {this.state.isLastRole && <FormattedMessage
                    id="label.org_contact_will_be_deleted"
                    defaultMessage="You are removing the last role this contact has in this organization. Do you want to keep the personal information as related contact or do you want to remove the contact completely from this organisation?"
                />}

              </div>
            </div>
            <br />
            <div className="row">
              <div className="col-xs-6">
                <Button
                  secondary
                  intlKey="button.cancel"
                  type="button"
                  onClick={() => this.props.modal(null)}
                >
                  Cancel
               </Button>

              </div>
              {!this.state.isLastRole && <div className="col-xs-6 text--right">
                <Button
                  negative
                  intlKey="button.confirm"
                  isLoading={submitting}
                  onClick={() => this.handleDeleteRole(this.state.roleToDelete, this.state.isOwnContact, this.state.roleCount, false)}
                >
                  Confirm
                </Button>
              </div>}

              {this.state.isLastRole && <div className="col-xs-6 text--right">
                <Button
                    negative
                    intlKey="button.no"
                    isLoading={submitting}
                    onClick={() => this.handleDeleteRole(this.state.roleToDelete, this.state.isOwnContact, this.state.roleCount, true)}
                >
                  No
                </Button>
                <Button
                    style={{ marginLeft: '10px' }}
                    intlKey="button.yes"
                    isLoading={submitting}
                    onClick={() => this.handleDeleteRole(this.state.roleToDelete, this.state.isOwnContact, this.state.roleCount, false)}
                >
                  Yes
                </Button>
              </div>}
            </div>
          </div>
        </Modal>

      </Section>
    )
  }
}

export default enhance(RoleChange)
